// Anchor navigation that works with Lenis smooth scroll.
export const scrollToSection = (selector, offset = 0) => {
  const lenis = window.__lenis;
  const el =
    typeof selector === "string" ? document.querySelector(selector) : selector;
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToTop = () => {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(0, { duration: 1.2 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};
